module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 var totalTrNum = 0; $.each([roomTypeBasesRecommend, roomTypeBases], function(index, roomTypeBases){ var typeText = index === 0 ? 'recommend' : 'others' ;
__p += '\n<table class="hotel-price-table hotel-detail-price-table' +
((__t = ( index === 0 ? ' recommend-table' : '' )) == null ? '' : __t) +
'' +
((__t = ( roomTypeBases.length > 0 ? '' : ' hidden')) == null ? '' : __t) +
'">\n	<thead class="hotel-price-thead hotel-detail-price-thead' +
((__t = ( index === 0 ? ' recommend-thead' : '')) == null ? '' : __t) +
'">\n	<tr>\n        ';
 if (index === 0){ ;
__p += '\n		<th width="260"><span class="hot-room-span">超值房型<i class="hot-room"></i></span></th>\n        ';
 }else{ ;
__p += '\n		<th width="260">特色房型</th>\n        ';
 } ;
__p += '\n		<th  width="190">价格类型</th>\n		<th width="150" class="align-center"><span>床型/早餐</span></th>\n		<th>预订规则</th>\n		<th>取消规则</th>\n		<th>剩余数量</th>\n		<th width="160">均价/总价</th>\n		<th width="115">预订</th>\n	</tr>\n	</thead>\n\n	<tbody class="hotel-price-tbody' +
((__t = ( index === 0 ? ' recommend-tbody' : '')) == null ? '' : __t) +
' ' +
((__t = ( index===1 ? 'myBody' : '' )) == null ? '' : __t) +
'" data-infoid="' +
((__t = ( hotelId )) == null ? '' : __t) +
'">\n	';
 for(var i = 0; i < roomTypeBases.length; i++){ var n = roomTypeBases[i]; ;
__p += '\n\n		';
 for(var j = 0; j < n.roomTypePrices.length; j++){ var o = n.roomTypePrices[j]; totalTrNum++; ;
__p += '\n        <!-- index === 1 && j === 0 ? \' mytr\' : index === 0 && j === 1 ? \' mytr\' : \'\' -->\n		<tr class="hotel-price-tr\n            ' +
((__t = ( j === 0 ? '' : ' auto-hide-tr' )) == null ? '' : __t) +
'\n            ' +
((__t = ( totalTrNum > 3 ? ' auto-hide' : '' )) == null ? '' : __t) +
' \n            ' +
((__t = ( index === 1 && j === 0 ? ' newmytr' : index === 0 && j === 1 ? ' newmytr' : '' )) == null ? '' : __t) +
'\n            ' +
((__t = ( index === 1 && j === 0 ? ' mytr' : '' )) == null ? '' : __t) +
'\n            ' +
((__t = ( index === 1 && j > 2 ? ' click-btn-css' : '' )) == null ? '' : __t) +
'\n            ' +
((__t = ( index === 1 ? ' borderTr' + i : '' )) == null ? '' : __t) +
'\n            ' +
((__t = ( index === 1 && j === 0 ? ' firstBorderTr' + i : '' )) == null ? '' : __t) +
'\n            ' +
((__t = ( index === 1 && i > 0 ? ' gt-one-tr' : '' )) == null ? '' : __t) +
'"  \n\n			data-show="' +
((__t = ( index===1 && (n.roomTypePrices.length - 1) == j ? 'true' : index===0? 'true' : 'false' )) == null ? '' : __t) +
'"\n        >\n\n            <!-- 第一个td -->\n			<td class="first-td' +
((__t = (
				(j === 0 && n.roomTypePrices.length > 1) ? ' no-border-bottom-td' :
				(j > 0 && j == n.roomTypePrices.length - 1) ? ' no-border-top-td' :
				(j > 0 && j < n.roomTypePrices.length - 1) ? ' no-border-td' : ''
			)) == null ? '' : __t) +
'" data-type="' +
((__t = ( typeText )) == null ? '' : __t) +
'">\n				<span class="hp-roomName' +
((__t = ( j === 0 || (ch == 3 && n.roomName == '其他 Other') ? '' : ' hidden' )) == null ? '' : __t) +
'"\n					roomid="' +
((__t = ( o.roomId )) == null ? '' : __t) +
'"\n					hotelid="' +
((__t = ( o.hotelId )) == null ? '' : __t) +
'"\n					supplierid="' +
((__t = ( o.supplierId )) == null ? '' : __t) +
'"\n					data-type="' +
((__t = ( typeText )) == null ? '' : __t) +
'"\n					data-track="详情页_酒店项_展开房型" >\n\n                    ';
 if(ch == 3 && n.roomName && n.roomName == "其他 Other"){ ;
__p += '\n						' +
((__t = ( o.roomName )) == null ? '' : __t) +
'\n                    ';
 }else{ ;
__p += '\n					    ' +
((__t = ( n.roomName )) == null ? '' : __t) +
'\n                    ';
 } ;
__p += '\n\n                    ';
 if(n.roomTypePrices.length > 1 && index ===1){ ;
__p += '\n						<!-- <i class="room-type-icon room-type-down"></i> -->\n                    ';
 } ;
__p += '\n					';
 if(n.roomTypePrices.length > 1 && index ===0){ ;
__p += '\n						<!-- <i class="room-type-icon room-type-up"></i>	 -->\n					';
 } ;
__p += '	\n				</span>\n			</td>\n\n            <!-- 第二个td -->\n			<td class="has-border-td yu-ding">\n                ';
 if(n.roomName && n.roomName == "其他 Other" && ch != 3){ ;
__p += '\n                <p \n                    style="\n                    max-width: 100%;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    font-weight: bold;\n                    display: -webkit-box;\n                    -webkit-box-orient: vertical;\n                    -webkit-line-clamp: 2;"\n                    title="' +
((__t = ( o.roomName )) == null ? '' : __t) +
'"\n                >\n                    ' +
((__t = ( o.roomName )) == null ? '' : __t) +
'\n                </p>\n                ';
 } ;
__p += '\n                \n                <span class="span-title" title="' +
((__t = ( o.rateTypeName || '' )) == null ? '' : __t) +
'" >' +
((__t = ( o.rateTypeName || '' )) == null ? '' : __t) +
'</span>\n                \n                <!-- 是否直采,isOwn等于1 -->\n                ';
 if(o.isOwn && o.isOwn == 1){ ;
__p += '\n                <div class="zhicai-div">\n                    <img src="https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1721721843566.gif" alt="">\n                    <div class="zhicai-all">\n                        <div class="zhicai-dialog">\n                            <span class="zhicai-dialog_text">准确率更高，库存更稳定，响应更及时</span>\n                            <div class="zhicai-dialog_ico"></div>\n                        </div>\n                    </div>\n                </div>\n                ';
 } ;
__p += '\n                \n				';
 if(o.isHasMarketing){ ;
__p += '\n				<!-- <i class="marketing-icon" data-tip="' +
((__t = ( encodeURIComponent(o.marketingInfo) )) == null ? '' : __t) +
'"></i> -->\n                <div class="tooltip-base">\n                    <i class="marketing-icon-base"></i>\n                    <span class="tooltiptext">' +
((__t = ( o.marketingInfo )) == null ? '' : __t) +
'</span>\n                </div>\n				';
 } ;
__p += '\n\n				';
 if(o.productDesc){ ;
__p += '\n				<!-- <i class="marketing-icon" data-tip="' +
((__t = ( encodeURIComponent(o.productDesc) )) == null ? '' : __t) +
'"></i> -->\n                <div class="tooltip-base">\n                    <i class="marketing-icon-base"></i>\n                    <span class="tooltiptext">' +
((__t = ( o.productDesc )) == null ? '' : __t) +
'</span>\n                </div>\n\n				';
 } ;
__p += '\n\n				';
 if(o.packageRequest){ ;
__p += '\n				<i class="pagekage-icon"></i>\n				';
 } ;
__p += '\n\n				\n				<!-- 新增按钮 -->\n				';
 if(n.roomTypePrices.length > 1 && index ===1){ ;
__p += '\n				<!-- <span class="new-btn hp-roomName' +
((__t = ( j === 0 ? '' : ' hidden' )) == null ? '' : __t) +
'"\n					roomid="' +
((__t = ( o.roomId )) == null ? '' : __t) +
'"\n					hotelid="' +
((__t = ( o.hotelId )) == null ? '' : __t) +
'"\n					supplierid="' +
((__t = ( o.supplierId )) == null ? '' : __t) +
'"\n					data-type="' +
((__t = ( typeText )) == null ? '' : __t) +
'"\n					data-track="详情页_酒店项_展开房型"   >\n						<span>更多</span>\n						<i class="room-type-icon room-type-down"></i>\n				</span> -->\n				';
 } ;
__p += '\n				<!-- 新增按钮  超值房型表格!!!!##### -->\n				';
 if(n.roomTypePrices.length > 1 && index ===0){ ;
__p += '\n				<!-- <span class="new-btn hp-roomName' +
((__t = ( j !== 0 ? '' : ' hidden' )) == null ? '' : __t) +
'"\n					roomid="' +
((__t = ( o.roomId )) == null ? '' : __t) +
'"\n					hotelid="' +
((__t = ( o.hotelId )) == null ? '' : __t) +
'"\n					supplierid="' +
((__t = ( o.supplierId )) == null ? '' : __t) +
'"\n					data-type="' +
((__t = ( typeText )) == null ? '' : __t) +
'"\n					data-track="详情页_酒店项_展开房型" >\n						<span>收起</span>\n						<i class="room-type-icon room-type-up"></i>	\n				</span> -->\n				';
 } ;
__p += '	\n			</td>\n\n            <!-- 第三个td -->\n			<td class="align-center">\n				';
 if(o.bedTypeName){ ;
__p += '\n				<p><span>' +
((__t = ( o.bedTypeName.split('[')[0] )) == null ? '' : __t) +
'</span></p>\n				';
 } ;
__p += '\n				<p><span class="' +
((__t = ( o.breakFastId == -2 ? 'multi-breakfast' : '' )) == null ? '' : __t) +
'">' +
((__t = ( o.breakFastName || '' )) == null ? '' : __t) +
'</span></p>\n			</td>\n\n            <!-- 第四个td -->\n            <td>\n                <span class="hp-order-clause">预定条款</span>\n                ';
 if(o.suppOtaChannel){ ;
__p += '\n                <span class="supp-ota" data-tip="禁售渠道：' +
((__t = ( o.suppOtaChannel )) == null ? '' : __t) +
'">OTA</span>\n                ';
 } ;
__p += '\n            </td>\n\n            <!-- 第五个td -->\n			<td>\n                <span class="hp-cancel-clause' +
((__t = ( o.cancellationText === '可取消' ? ' green' : '')) == null ? '' : __t) +
'" data-tip="' +
((__t = ( o.cancellationDesc )) == null ? '' : __t) +
'">' +
((__t = ( o.cancellationText )) == null ? '' : __t) +
'</span>\n            </td>\n\n            <!-- 第六个td -->\n			<td>\n                <span class="hp-store-status">' +
((__t = ( o.roomStatusText )) == null ? '' : __t) +
'</span>\n            </td>\n\n            <!-- 第七个td -->\n			<td>\n				<span class="hp-currency">均 ￥<span class="hp-average-price-num">' +
((__t = ( o.averagePriceRMB.toFixed(2).replace(/(\.0+|0+)$/, '') )) == null ? '' : __t) +
'</span></span>\n				<br>\n				<span class="hp-total-price">总 ￥<span class="hp-total-price-num">' +
((__t = ( o.totalPriceRMB )) == null ? '' : __t) +
'</span></span>\n			</td>\n\n            <!-- 第八个td 预订按钮 -->\n			<td class="last-td">\n				';
 if(o.isBook){ ;
__p += '\n					<a href="javascript:;" class="hp-order-btn' +
((__t = ( index === 0 ? ' orange' : ' blue')) == null ? '' : __t) +
'"\n						data-supplierId="' +
((__t = ( o.supplierId )) == null ? '' : __t) +
'"\n						data-hotelId="' +
((__t = ( o.hotelId )) == null ? '' : __t) +
'"\n						data-roomId="' +
((__t = ( o.roomId )) == null ? '' : __t) +
'"\n						data-breakFastId="' +
((__t = ( o.breakFastId )) == null ? '' : __t) +
'"\n						data-paymentType="' +
((__t = ( o.paymentType )) == null ? '' : __t) +
'"\n						data-rateType="' +
((__t = ( o.rateType )) == null ? '' : __t) +
'"\n						data-marketingStr="' +
((__t = ( o.marketingStr )) == null ? '' : __t) +
'" \n                        data-arriveStartTime="' +
((__t = ( (o.policies || o.checkInInstructions || o.specialCheckInInstructions) && o.arriveStartTime ? o.arriveStartTime : '' )) == null ? '' : __t) +
'"\n                        data-arriveEndTime="' +
((__t = ( (o.policies || o.checkInInstructions || o.specialCheckInInstructions) && o.arriveEndTime ? o.arriveEndTime : '' )) == null ? '' : __t) +
'"\n                        data-checkOutTime="' +
((__t = ( (o.policies || o.checkInInstructions || o.specialCheckInInstructions) && o.addAttrMap && o.addAttrMap.checkOutTime ? o.addAttrMap.checkOutTime : '' )) == null ? '' : __t) +
'" \n                        >\n\n						<span class="hidden nightlyPriceList">' +
((__t = ( window.JSON.stringify(o.nightlyPriceList) )) == null ? '' : __t) +
'</span>\n						<span class="hidden hotelPriceStrs">' +
((__t = ( encodeURIComponent( window.JSON.stringify(o) ) )) == null ? '' : __t) +
'</span>\n\n                        ';
 if(o.policies){ ;
__p += '\n                            <div class="hidden hotelPolicies">' +
((__t = ( o.policies )) == null ? '' : __t) +
'</div>\n                        ';
 } ;
__p += '\n\n                        ';
 if(o.addAttrMap && o.addAttrMap.fees_mandatory){ ;
__p += '\n                            <div class="hidden fees_mandatory">' +
((__t = ( o.addAttrMap.fees_mandatory )) == null ? '' : __t) +
'</div>\n                        ';
 } ;
__p += '\n                        ';
 if(o.addAttrMap && o.addAttrMap.fees_optional){ ;
__p += '\n                            <div class="hidden fees_optional">' +
((__t = ( o.addAttrMap.fees_optional )) == null ? '' : __t) +
'</div>\n                        ';
 } ;
__p += '\n					</a>\n\n                    <!-- 实时数据不显示日历价skuid = -1为实时 -->\n                    ';
 if(o.nightlyPriceList[0].skuId && o.nightlyPriceList[0].skuId != -1){ ;
__p += '\n                    <div \n                        class="calendar-price-div jump-order-btn"\n                        id="beforeJumpSearchPrice"\n                        data-hotelId="' +
((__t = ( o.hotelId )) == null ? '' : __t) +
'"\n                        data-roomId="' +
((__t = ( o.roomId )) == null ? '' : __t) +
'"\n                        data-supplierId="' +
((__t = ( o.supplierId )) == null ? '' : __t) +
'"\n                        data-rateType="' +
((__t = ( o.rateType )) == null ? '' : __t) +
'"\n                        data-marketingStr="' +
((__t = ( o.marketingStr )) == null ? '' : __t) +
'"\n                        data-currency="' +
((__t = ( o.currency )) == null ? '' : __t) +
'"\n                    >\n                        <img src="https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1720000432387.png" alt="" class="calendar-price-img jump-order-btn">\n                        <span class="calendar-price-span jump-order-btn">日历价</span>\n                    </div>\n                    ';
 } ;
__p += '\n\n\n				';
 }else{ ;
__p += '\n					<a href="javascript:;" class="hp-order-btn disabled"><span class="hidden nightlyPriceList">' +
((__t = ( window.JSON.stringify(o.nightlyPriceList) )) == null ? '' : __t) +
'</span><span class="hidden hotelPriceStrs">' +
((__t = ( o.hotelPriceStrs )) == null ? '' : __t) +
'</span></a>\n                    \n                    <!-- 实时数据不显示日历价skuid = -1为实时 -->\n                    ';
 if(o.nightlyPriceList[0].skuId && o.nightlyPriceList[0].skuId != -1){ ;
__p += '\n                    <div \n                        class="calendar-price-div jump-order-btn"\n                        id="beforeJumpSearchPrice"\n                        data-hotelId="' +
((__t = ( o.hotelId )) == null ? '' : __t) +
'"\n                        data-roomId="' +
((__t = ( o.roomId )) == null ? '' : __t) +
'"\n                        data-supplierId="' +
((__t = ( o.supplierId )) == null ? '' : __t) +
'"\n                        data-rateType="' +
((__t = ( o.rateType )) == null ? '' : __t) +
'"\n                        data-marketingStr="' +
((__t = ( o.marketingStr )) == null ? '' : __t) +
'"\n                        data-currency="' +
((__t = ( o.currency )) == null ? '' : __t) +
'"\n                    >\n                        <img src="https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1720000432387.png" alt="" class="calendar-price-img jump-order-btn">\n                        <span class="calendar-price-span jump-order-btn">日历价</span>\n                    </div>\n                    ';
 } ;
__p += '\n\n				';
 } ;
__p += '\n			</td>\n\n		</tr>\n		';
 } ;
__p += '\n\n        <!-- 新的展开更多价格 -->\n        ';
 if(index == 1 && n.roomTypePrices.length > 3 && (ch != 3 || n.roomName !== "其他 Other")){ ;
__p += '\n            <tr class="show-more-tr' +
((__t = ( i > 0 ? ' gt-one-tr' : '' )) == null ? '' : __t) +
'">\n                <td class="show-more-td1"></td>\n\n                <td colspan="8" class="show-more-td2"\n                    data-index="' +
((__t = ( i )) == null ? '' : __t) +
'"\n                    data-type="' +
((__t = ( typeText )) == null ? '' : __t) +
'"\n                    data-track="详情页_酒店项_展开房型"   \n                >\n                    <span>更多价格</span>\n                    <i class="room-type-icon room-type-down"></i>\n                </td>\n\n            </tr>\n        ';
 } ;
__p += '\n\n	';
 } ;
__p += '\n	</tbody>\n\n\n\n    <!-- 底部展开全部 -->\n	';
 if(index == 1 && roomTypeBases.length > 1){ ;
__p += '\n	<tfoot>\n		<tr>\n			<td colspan="9">\n				<div class="hli-expand-inner" data-hotelid="35429" data-track="详情页_酒店项_展开全部房型">\n					<span>收起全部房型</span>\n					<i class="hli-icon icon-up"></i>\n				</div>\n			</td>\n		</tr>\n	</tfoot>\n	';
 } ;
__p += '\n</table>\n';
 }) ;
__p += '\n\n\n\n<script>\n    //let pageFrom = \'hotelDetail\';  //定义一个变量,区分展开收起来自详情页面;\n    $.pageFrom = \'hotelDetail\';\n	//根据文字长度改变height\n	// function changeHeight() {\n	// 	let btn = $(\'.newmytr\').find($(\'.span-title\')) \n	// 	$.each(btn,function(index,item){\n	// 		// console.log(\'我在这\',$(this).html().length);\n    //         let lengthNum = $(this).html().length\n	// 		if(lengthNum>13 && lengthNum<=26 ){\n    //             // console.log(111);\n	// 			$(this).css({\n	// 				height:\'92px\'\n	// 			})\n	// 		} else if(lengthNum>26 && lengthNum<=39) {\n    //             // console.log(222);\n	// 			$(this).css({\n	// 				height:\'95px\',\n    //                 alignItems: \'start\',\n    //                 paddingTop:\'7px\'\n	// 			})\n	// 		}  else {\n                \n    //         }\n	// 	})\n	// }\n	// changeHeight()\n\n\n	\n	// function changeType(){\n	// 	var _table =  $("table") || \'\';\n	// 	var _this = $(_table).find(\'.hp-roomName\')\n	// 			typeText = _this.attr(\'data-type\'),\n	// 			typeTd = _this.closest(\'table\').find(\'.first-td[data-type=\' + typeText + \']\'),\n	// 			spanRow = +typeTd.attr(\'rowspan\'),\n	// 			thisTd = _this.closest(\'td\'),\n	// 			dragIcon = _this.find(\'.room-type-icon\');\n		\n	// 	let sameRoomTypeTrs = $(\'.myBody\').find(\'.auto-hide-tr\')			\n	// 	$.each(sameRoomTypeTrs, function(i, o) {\n			\n	// 		setTimeout(function(){\n	// 			$(o).find(\'td\').addClass(\'hidden\');\n	// 		}, 80);\n\n	// 		$(o).slideUp(\'fast\');\n	// 	});\n	// }\n	// changeType()\n\n	\n\n</script>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/js/hotelDetail/templates/priceTableTmpl.ejs
// module id = 212
// module chunks = 6